// extracted by mini-css-extract-plugin
export default {"root":"BK57kgqas4VjljGU32r6","tab":"ukNcWfI8vpxcIvrkAMme","approveCheckbox":"AIIgccOzNIiqWc1zFF7o","bold":"OcjWYsHRQBNf0TLcejxQ"};